import { getIsMarqeta } from 'modules/company/redux/selectors';
import { type AppState } from 'src/core/reducers';
import { getCompany } from 'src/core/selectors/globalSelectors';
import { getSelf } from 'src/core/selectors/users';

import { type Account, type UserFactor } from '../wallet';

export const getAccount = (state: AppState): Account | undefined => {
  return state.wallet.account;
};

export const getIsWalletFundingNavVisible = (state: AppState): boolean => {
  const company = getCompany(state);
  const isMarqeta = getIsMarqeta(state);
  const account = getAccount(state);
  const user = getSelf(state);

  return (
    !company?.churning_at &&
    (company?.has_public_banking_address ||
      (account && isMarqeta && (user.is_account_owner || user.is_admin)))
  );
};

export const getIsWalletFundingSourceNavVisible = (
  state: AppState,
): boolean => {
  const company = getCompany(state);
  const isMarqeta = getIsMarqeta(state);
  const account = getAccount(state);
  const user = getSelf(state);

  return (
    !company?.churning_at &&
    account &&
    isMarqeta &&
    (user.is_account_owner || user.is_admin)
  );
};

export const getUserPlaceholderAmountWithCurrency = (
  state: AppState,
): string => {
  const company = getCompany(state);
  const user = getSelf(state);

  if (!company || !user) {
    return '';
  }

  const getPlaceholderAmountWithCurrency = (
    currency: string,
    lang: string,
  ): string => {
    const amountParts = new Intl.NumberFormat(lang, {
      style: 'currency',
      currency,
    })
      .formatToParts(0)
      .filter((x) => x.type === 'currency' || x.type === 'integer');
    const currencyPart = amountParts.find((part) => part.type === 'currency');
    if (!currencyPart) {
      return '—';
    }
    return `${amountParts[0].value} ${amountParts[1].value}`.replace(
      /\d+/,
      '—',
    );
  };

  return getPlaceholderAmountWithCurrency(company.currency, user.lang) ?? '';
};

export const getPhoneUserFactor = (state: AppState): UserFactor | undefined => {
  return state.wallet.phoneUserFactor;
};
export const getIsLoadingPhoneUserFactor = (state: AppState): boolean => {
  return state.wallet.isLoadingPhoneUserFactor;
};
